<his-plam [label]="setting().label | hisUi"
          [helptext]="setting().helptext | hisUi" [required]="setting().required"
          [title]="title()">
    <textarea #content [(ngModel)]="setting().value" class="textareaWidth100 expand" rows="1"
              [readonly]="setting().readonly"
              [minlength]="+setting().minLength || undefined"
              [maxlength]="+setting().maxLength || undefined"
              [pattern]="setting().regex || undefined"></textarea>
</his-plam>
